import React from 'react';
import { Tooltip } from 'recharts';
import { PieChart as RechartsPieChart, Pie, ResponsiveContainer } from 'recharts';

const PieChart = ({ data, height }) => {
  // ROY G BIV
  const colors = [
    '#dc3545',
    '#fd7e14',
    '#ffc107',
    '#198754',
    '#0d6efd',
    '#6610f2',
    '#6f42c1',
    '#d63384',
    '#20c997',
    '#0dcaf0',
    '#6c757d',
    '#212529'
  ];

  let dataArray = Object.entries(data).map(([key, value], index) => ({
    name: key,
    value,
    fill: colors[index % colors.length]
  }));

  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <RechartsPieChart>
          <Pie dataKey="value" data={dataArray} outerRadius={'60%'} label={entry => entry.name}>
            {dataArray.map(entry => entry.fill)}
          </Pie>
          <Tooltip />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChart;
